var loc = document.querySelectorAll("span.dot");

loc.forEach(node => {
    node.addEventListener("mouseover", locOver);
})

function locOver(event) {

  var newURL = event.target.dataset.variantimage;
  var imageToUpdate = event.target.dataset.imageblock;
  
  var elementToUpdate = document.querySelector("." + imageToUpdate);
  
  console.log(elementToUpdate);
    
  elementToUpdate.src = newURL;    
  elementToUpdate.srcset = newURL;
}
